import { object, string } from 'yup';
import i18n from '../../i18n';
const trans = i18n.t;

export const PLANS = {
  free: {
    userLimit: 5,
    subscriberLimt: 250
  },
  high: {
    userLimit: 20,
    subscriberLimt: 5000
  }
};

export const getAccountDetails = accounts => {
  const activeAccountId = Number(localStorage.getItem('active-account'));
  let requiredIndex = 0;
  // eslint-disable-next-line no-plusplus
  for (let count = 0; count < accounts.length; count++) {
    if (accounts[count].id === activeAccountId) {
      requiredIndex = count;
      break;
    }
  }
  // this.setState({
  //   currentAccount: accounts[requiredIndex],
  // })
  return accounts[requiredIndex];
};

export const userMgmtGroup = [
  {
    id: 'usersV2',
    label: trans('screens.settings.constant.agents'),
    url: '/users',
    viewBox: '-5 0 50 50'
  },
  {
    id: 'internalNotificationV2',
    label: trans('screens.settings.constant.internalNotification'),
    url: '/team'
  },
  {
    id: 'emailSettings',
    label: trans('screens.settings.constant.emailSettings'),
    url: '/email-settings'
  },
  {
    id: 'emailNotification',
    label: trans('screens.settings.constant.emailNotification'),
    url: '/email-notification',
    subChildren: [
      {
        id: 'subscriber-notification',
        label: trans('screens.settings.constant.subscriberNotification'),
        url: '/SB'
      },
      {
        id: 'admin-only-notification',
        label: trans('screens.settings.constant.adminNotification'),
        url: '/AO'
      },
      {
        id: 'agent-notification',
        label: trans('screens.settings.constant.agentNotification'),
        url: '/AG'
      }
    ]
  }
];

export const settingsSetup = [
  {
    id: 'accountSettingsV2',
    label: trans('screens.settings.constant.accountSettings'),
    url: '/accounts'
  }
  // {
  //   id: 'pricingAndPlansV2',
  //   label: 'Pricing and plans',
  //   url: '/plans',
  //   viewBox: '-5 0 50 50'
  // }
];

export const settingsConfigure = [
  {
    id: 'incidentTemplatesV2',
    label: trans('screens.settings.constant.templates'),
    url: '/templates'
  },
  {
    id: 'cannedresponses',
    label: trans('screens.settings.constant.cannedResponse'),
    url: '/cannedresponses'
  },
  {
    id: 'incidentSources',
    label: trans('screens.settings.constant.incidentsource'),
    url: '/source'
  },
  {
    id: 'incidentStatus',
    label: trans('screens.settings.constant.incidentStatus'),
    url: '/incident-status'
  },
  {
    id: 'integrationsV2',
    label: trans('screens.settings.constant.integrations'),
    url: '/integration',
    subChildren: [
      {
        id: 'webhook',
        label: trans('screens.settings.constant.webhook'),
        url: '/webhook'
      },
      {
        id: 'freshDesk',
        label: trans('screens.settings.constant.freshdesk'),
        url: '/freshdesk'
      },
      {
        id: 'freshService',
        label: trans('screens.settings.constant.freshservice'),
        url: '/freshservice'
      },
      {
        id: 'freshPing',
        label: trans('screens.settings.constant.freshping'),
        url: '/freshping'
      }
    ]
  }
];

export const subscriberConfigure = [
  {
    id: 'manageSubscribersV2',
    label: trans('screens.settings.constant.manageSubscribers'),
    url: '/subscribers'
  },
  {
    id: 'manageSubscription',
    settingsLabel: trans('screens.settings.constant.subscriptionAndAccessControl'),
    label: trans('screens.settings.constant.subscriptionAndAccessControl'),
    url: '/manage-subscription',
    subChildren: [
      {
        id: 'statusPagePrivacy',
        label: trans('screens.settings.constant.statuspagePrivacy'),
        url: '/privacy'
      },
      {
        id: 'subscriptionOptions',
        label: trans('screens.settings.constant.subscriptionChannels'),
        url: '/subscription-options'
      }
    ]
  }
];

export const SOURCE_VALIDATION_SCHEMA = object().shape({
  value: string()
    .trim()
    .min(3, trans('screens.settings.constant.minValueCharacters'))
    .max(90, trans('screens.settings.constant.maxValueCharacters'))
    .required(trans('screens.settings.constant.fieldRequired'))
});
export const TEMPLATES_VALIDATION_SCHEMA = object().shape({
  title: string()
    .trim()
    .min(3, trans('screens.settings.constant.minTitleCharacter'))
    .max(280, trans('screens.settings.constant.maxTitleCharacter'))
    .required(trans('screens.settings.constant.titleRequired')),
  description: string()
    .trim()
    .min(3, trans('screens.settings.constant.minDescription'))
    .max(5000, trans('screens.settings.constant.maxDescription'))
    .required(trans('screens.settings.constant.descriptionRequired'))
});
export const CANNEDR_VALIDATION_SCHEMA = object().shape({
  name: string()
    .trim()
    .min(3, trans('screens.settings.constant.minNameCharacters'))
    .max(90, trans('screens.settings.constant.maxNameCharacters'))
    .required(trans('screens.settings.constant.nameRequired')),
  description: string()
    .trim()
    .min(3, trans('screens.settings.constant.minDescription'))
    .max(5000, trans('screens.settings.constant.maxDescription'))
    .required(trans('screens.settings.constant.descriptionRequired'))
});
